export const HEADER_HEIGHT = 56;

export const CASHED_URL = 'cashedURL';
